var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashCanB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.5,41.7c0,3.5,2.8,6.3,6.3,6.3h22.5c3.5,0,6.3-2.8,6.3-6.3V11.6h-35V41.7z M9.5,14.6h29v27.1c0,1.8-1.5,3.3-3.3,3.3H12.8 c-1.8,0-3.3-1.5-3.3-3.3V14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4,5.7l-2-5.7H16.6l-2,5.7H6.5v3h35.1v-3H33.4z M17.8,5.7L18.8,3h10.5l0.9,2.7H17.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 20.2,
    width: 3,
    height: 19.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.1,
    y: 20.2,
    width: 3,
    height: 19.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.9,
    y: 20.2,
    width: 3,
    height: 19.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCanB);
export default __webpack_public_path__ + "static/media/trash-can-b.1cfdad78d5291dae4a81128279ba6d75.svg";
export { ForwardRef as ReactComponent };